import { render, staticRenderFns } from "./return-warehouse.vue?vue&type=template&id=06aa34c0&scoped=true"
import script from "./return-warehouse.vue?vue&type=script&lang=js"
export * from "./return-warehouse.vue?vue&type=script&lang=js"
import style0 from "./return-warehouse.vue?vue&type=style&index=0&id=06aa34c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06aa34c0",
  null
  
)

export default component.exports